import { render, staticRenderFns } from "./InspectionItemList.vue?vue&type=template&id=3420fc16&scoped=true&"
import script from "./InspectionItemList.vue?vue&type=script&lang=js&"
export * from "./InspectionItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420fc16",
  null
  
)

export default component.exports